/* Zahra Fragrance — lightweight visual enhancements only.

   Rev 3 (2026-08-16), performance pass:
   - The old version re-queried every video and review widget on a 700ms timer, 15
     times per page load. That is 15 full DOM sweeps competing with rendering on
     mobile. Replaced with one MutationObserver that only does work when the page
     actually changes, and that costs nothing once the page settles.
   - Videos more than one and a half screens below the fold now start at
     preload="none" and are restored to their original preload value when the reader
     gets near them. Autoplaying videos are left completely alone.
*/
(function () {
  'use strict';

  if (window.__zahraConversion) return;
  window.__zahraConversion = true;

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function sharpenPoster(video) {
    var poster = video.getAttribute('poster');
    if (!poster || video.dataset.zfPoster === '1') return;
    video.dataset.zfPoster = '1';
    if (poster.indexOf('_small.') === -1) return;

    var largerPoster = poster.replace('_small.', '_1024x.');
    var probe = new Image();
    probe.onload = function () {
      if (probe.naturalWidth > 200) video.setAttribute('poster', largerPoster);
    };
    probe.src = largerPoster;
  }

  var videoObserver = null;
  if ('IntersectionObserver' in window) {
    videoObserver = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          if (!entries[i].isIntersecting) continue;
          var video = entries[i].target;
          videoObserver.unobserve(video);
          video.preload = video.dataset.zfPreload || 'metadata';
        }
      },
      { rootMargin: '600px 0px' }
    );
  }

  function deferVideo(video) {
    if (!videoObserver) return;
    // Autoplaying background video is the theme's job, not ours. Do not touch it.
    if (video.autoplay) return;
    if (video.getAttribute('preload') === 'none') return;

    var rect = video.getBoundingClientRect();
    var viewport = window.innerHeight || 800;
    if (rect.top < viewport * 1.5) return;

    video.dataset.zfPreload = video.getAttribute('preload') || 'metadata';
    video.preload = 'none';
    videoObserver.observe(video);
  }

  function pauseOthers(event) {
    var allVideos = document.querySelectorAll('video');
    for (var j = 0; j < allVideos.length; j += 1) {
      if (allVideos[j] !== event.target && !allVideos[j].paused) {
        try { allVideos[j].pause(); } catch (error) {}
      }
    }
  }

  function wireVideos() {
    var videos = document.querySelectorAll('video');
    for (var i = 0; i < videos.length; i += 1) {
      var video = videos[i];
      sharpenPoster(video);
      if (video.dataset.zfWired === '1') continue;
      video.dataset.zfWired = '1';
      video.setAttribute('playsinline', '');
      video.addEventListener('play', pauseOthers);
      deferVideo(video);
    }
  }

  function hideEmptyReviews() {
    var widgets = document.querySelectorAll('.jdgm-widget, .jdgm-horizon-widget, [class*="jdgm-rev-widg"]');
    for (var i = 0; i < widgets.length; i += 1) {
      var text = (widgets[i].textContent || '').toLowerCase();
      var section = widgets[i].closest('.shopify-section') || widgets[i];
      if (text.indexOf('be the first to write a review') !== -1) section.classList.add('zf-hide-empty-reviews');
      else section.classList.remove('zf-hide-empty-reviews');
    }
  }

  var queued = false;

  function run() {
    queued = false;
    wireVideos();
    hideEmptyReviews();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(run, { timeout: 500 });
    else window.setTimeout(run, 120);
  }

  ready(function () {
    run();
    // Apps and section re-renders inject nodes after load. Watching childList only
    // means our own class and attribute writes cannot retrigger this.
    if ('MutationObserver' in window && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  });

  window.addEventListener('load', schedule, { once: true });
})();
